export default {
  search: {
    title: "Suche",
    trending: "Trending",
    noResults: 'Keine Ergebnisse für "{{query}}" gefunden',
    sections: {
      games: "Spiele",
      props: "Props",
      position: "Position",
      trending: "Trending",
      players: "Spieler",
      teams: "Teams",
      markets: "Märkte",
      matchups: "Matchups",
    },
    empty: {
      noResults: 'Keine Ergebnisse für "{{query}}" gefunden',
      noGamesAvailable: "Keine Spiele verfügbar",
      checkBackLater: "Bitte später erneut vorbeischauen",
    },
    actions: {
      searchByGame: "Nach Spiel suchen",
      viewMatchups: "Matchups anzeigen",
      searchByProp: "Nach Prop suchen",
      searchByPosition: "Nach Position suchen",
    },
    discovery: {
      Hits: "Hits",
      "Total Bases": "Total Bases",
      RBI: "RBI",
      Strikeouts: "Strikeouts",
      Results: "Ergebnisse",
      Totals: "Totals",
      "Goals & Assists": "Tore & Assists",
      "Shots on Goal": "Schüsse aufs Tor",
      Points: "Punkte",
      "Powerplay Points": "Powerplay-Punkte",
    },
    positions: {
      Forwards: "Stürmer",
      Midfielders: "Mittelfeldspieler",
      Defense: "Verteidigung",
      Guards: "Guards",
      Centers: "Center",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Flügelspieler",
      Goalies: "Torhüter",
      Pitchers: "Pitcher",
      Hitters: "Hitter",
    },
  },
};
